/**
 * @Author          : SuXiao xiao.su_ext@novartis.com
 * @Date            : 2024-10-09 18:43:02
 * @LastEditors     : SuXiao xiao.su_ext@novartis.com
 * @LastEditTime    : 2025-03-03 09:35:34
 * @FilePath        : \wecom-front-end-admin-portal\src\router\mass-messaging.routes.ts
 * @Description     : [群发消息] 相关路由
 * @
 */
import { Role } from '@/model/schema';

const routes = [
  {
    // 群发消息分组设置
    path: '/sendMessagesGroupSet',
    name: 'sendMessagesGroupSet', // 群发消息分组设置
    component: () => import('../views/massmessaging/groupSet.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '群发消息分组设置',
      titleEn: 'Send Message Set'
    }
  },
  {
    // 群发消息分组设置 - 创建分组
    path: '/greatGroup',
    name: 'greatGroup',
    component: () => import('../views/massmessaging/massageAdd/creatGroup.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '分组设置',
      titleEn: 'Send Message Set'
    }
  },
  {
    // 专栏群发消息
    path: '/groupMessagesSpecial',
    name: 'groupMessagesSpecial', // 专栏群发消息
    component: () => import('../views/massmessaging/groupMessages.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '专栏群发消息',
      titleEn: 'Send Message'
    }
  },
  {
    // 专栏群发消息 - 创建预览名单
    path: '/creatRoster',
    name: 'creatRoster', // 专栏创建预览名单
    component: () => import('../views/massmessaging/massageAdd/creatRoster.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '创建预览名单',
      titleEn: 'Creat Roster'
    }
  },
  {
    // 专栏群发消息 - 创建群发消息
    path: '/creatMessage',
    name: 'creatMessage', // 专栏创建群发消息
    component: () => import('../views/massmessaging/massageAdd/creatMessage.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '创建群发消息',
      titleEn: 'Creat Message'
    }
  },
  {
    // 应用群发消息
    path: '/groupMessagesChannel',
    name: 'groupMessagesChannel', //应用群发消息
    component: () => import('../views/massmessaging/application/applicationMassage.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '应用群发消息',
      titleEn: 'Application Message'
    }
  },
  {
    // 应用群发消息 - 创建预览名单
    path: '/channelRoster',
    name: 'channelRoster',
    component: () => import('../views/massmessaging/application/creatRoster.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '创建预览名单',
      titleEn: 'Application Message'
    }
  },
  {
    // 应用群发消息 - 创建群发消息
    path: '/channelMessage',
    name: 'channelMessage',
    component: () => import('../views/massmessaging/application/creatMessage.vue'),
    meta: {
      roles: [Role.SUPER_ADMIN, Role.DIGITAL_ADMIN, Role.CHANNEL_ADMIN],
      auth: true,
      title: '创建群发消息',
      titleEn: 'Application Message'
    }
  },
]

export default routes;
